import { render, staticRenderFns } from "./ReviewPieChart.vue?vue&type=template&id=632b5abe&scoped=true&"
import script from "./ReviewPieChart.vue?vue&type=script&lang=js&"
export * from "./ReviewPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b5abe",
  null
  
)

export default component.exports